/* eslint-disable @typescript-eslint/no-unused-vars */
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Action } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';
import { retrieveSubscriptionsFailure, retrieveSubscriptionsSuccess } from '@store/scenario/subscription/subscription-slice';
import { Subscription } from '@scenario/models/subscription.model';

export const retrieveSubscriptionsEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
)=>
  action$.pipe(
    ofType('subscription/retrieveSubscriptions'),
    concatMap((_action: Action) =>
      from(dependencies.subscriptionGateway.retrieveAll()).pipe(
        map((subscriptions: Subscription[] ) =>  retrieveSubscriptionsSuccess(subscriptions)),
      catchError(() =>
        of(retrieveSubscriptionsFailure('Failed to retrieve subscriptions')),
      ),
    ),
  ),
);
